module.exports = __webpack_public_path__ + "assets/img/EXTERNAL_SOURCE_PLUGIN.19524397.svg";